const Urls = {
  index: '/',
  home: '/home',
  music: {
    index: '/music',
    release: '/music/:release'
  },
  features: {
    index: '/features',
    one: '/features/:feature'
  },
  about: {
    index: '/about'
  },
  video: {
    index: '/video'
  },
  tour: '/tour',
  contact: '/contact',
  live: '/live',
  press: '/press',
};

export default Urls;
